var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareArticleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8222 48.5152C52.6483 40.4263 55.7468 24.1857 47.7563 12.2274C39.7568 0.269066 23.6958 -2.86415 11.8697 5.21578C0.0436999 13.3047 -3.05486 29.5453 4.9357 41.5036C12.9351 53.4619 28.9962 56.5952 40.8222 48.5152Z",
    fill: "#C8E6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1398 17.5163L16.2024 24.7252L22.8445 28.5695L28.7013 22.7112C28.9984 22.4143 29.4012 22.2476 29.8213 22.2477C30.2413 22.2479 30.644 22.4149 30.9409 22.712C31.2378 23.0091 31.4045 23.4119 31.4043 23.8319C31.4042 24.252 31.2372 24.6547 30.9401 24.9516L25.0818 30.8099L28.9293 37.4504L36.1398 17.5163ZM36.6512 13.9633C38.5433 13.2777 40.3768 15.1112 39.6912 17.0033L31.328 40.1278C30.6409 42.0247 28.0505 42.2558 27.0388 40.5094L21.9452 31.7093L13.145 26.6157C11.3986 25.6039 11.6298 23.0136 13.5266 22.3264L36.6512 13.9633Z",
    fill: "#204A22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareArticleIcon);
export default __webpack_public_path__ + "static/media/share-article-icon.0cd504ba3c403f1463a6dbd201adcf73.svg";
export { ForwardRef as ReactComponent };